import React, { useState } from "react";
import { Box, Typography, Paper, Alert } from "@mui/material";
import { CampaignRounded, ChevronRightRounded } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import MarketingSettings from "components/dashboard/advertising/MarketingSettings";

const AdvertisingRequirements = ({ location, userData }) => {
  const [marketingOpen, setMarketingOpen] = useState(false);
  const [submitted, setSubmitted] = useState("");

  // Check if advertising profile is complete
  const hasBranding =
    location?.branding?.logo &&
    location?.branding?.website &&
    location?.branding?.tagline &&
    location?.group;

  return (
    <Box>
      {submitted && (
        <Alert severity="success" sx={{ mb: 3 }}>
          {submitted}
        </Alert>
      )}

      <Paper
        elevation={2}
        sx={{
          mb: 3,
          overflow: "hidden",
        }}
      >
        <Box sx={{ p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <CampaignRounded color="primary" sx={{ mr: 2, fontSize: 28 }} />
            <Typography variant="h5" sx={{ fontWeight: 500 }}>
              Complete Your Advertising Setup
            </Typography>
          </Box>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            To get started advertising your facility, you'll need to set up your
            advertising profile with some basic information and branding. All
            fields must be completed to finish your advertising profile. This
            information will help patients easily and connect with your
            facility.
          </Typography>

          <LoadingButton
            variant="contained"
            size="large"
            endIcon={<ChevronRightRounded />}
            onClick={() => setMarketingOpen(true)}
            sx={{ textTransform: "none" }}
          >
            {hasBranding
              ? "Update Advertising Profile"
              : "Complete Advertising Profile"}
          </LoadingButton>
        </Box>
      </Paper>

      {/* Settings Dialog - Only render when location is available */}
      {location && (
        <MarketingSettings
          user={userData}
          data={userData}
          location={location}
          visible={marketingOpen}
          close={() => setMarketingOpen(false)}
          setSubmitted={setSubmitted}
        />
      )}
    </Box>
  );
};

export default AdvertisingRequirements;
